module.exports = __webpack_public_path__ + "img/2x.40319c7.jpg";